import { useState, useCallback } from 'react'

export function useRemoveContact() {
  const [deleteContactId, setDeleteContactId] = useState<number>()

  const deleteContactOpen = !!deleteContactId

  const onClickDelete = useCallback(
    (contactId: number) => setDeleteContactId(contactId),
    [],
  )

  const onCloseDelete = useCallback(() => setDeleteContactId(undefined), [])

  return {
    onClickDelete,
    onCloseDelete,
    deleteContactId,
    deleteContactOpen,
  }
}
